export const ORDER_BLOTTER_ADD_COLUMN_FILTER = "order-blotter/add-column-filter";
export const ORDER_BLOTTER_RESET_COLUMN_FILTERS = "order-blotter/reset-column-filters";
export const ORDER_BLOTTER_REMOVE_COLUMN_FILTER = "order-blotter/remove-column-filter";
export const ORDER_BLOTTER_COPY_STATE = "order-blotter/copy-state";
